
import { Component, OnInit } from '@angular/core';
import { SystemTypeRegistration as SystemTypeRegistrationRepository } from './system-type-registration.service';
import { ApiResponse } from '../../models/api-response';
import { SystemTypeDetails } from './systemTypeDetails';
import { NotificationService } from "../../services/notification.service";

@Component({
    selector: 'system-type-registration',
    template: require('./system-type-registration.component.html')
})
export class SystemTypeRegistrationComponent {
    systemType: string;
    projectId: string;
    ownershipCodeGenerationType: string;
    createPermissionsOnlyInCallerIdentityProvider: boolean  = false;
    ownershipList: string[];
    invalidSystemType = false;
    responseData: any;
    isSuccessRetriever:boolean=false;
    resultMessage: string;
    retrievedSystemTypes: Array<SystemTypeDetails>;

    constructor(private systemTypeRepo: SystemTypeRegistrationRepository,
    private notifier: NotificationService) {
        this.ownershipList = ['None', 'BasicAlpha8'];
        this.ownershipCodeGenerationType = this.ownershipList[0];
        this.notifier.clear();
    }

    initializeCurrentTab() {
	    this.notifier.clear();
        this.isSuccessRetriever = false;
    }

    addSystemType() {
        this.notifier.displayInfo("Registering system type");
        this.isSuccessRetriever = false;
        this.systemType = (this.systemType == null) ? this.systemType : this.systemType.trim();
        var systemTypePattern = new RegExp("^[a-zA-Z0-9:-]{1,49}$");
        if (this.systemType == null || this.systemType === '' || systemTypePattern.test(this.systemType) === false) {

            this.invalidSystemType = true;
            this.notifier.displayError("Please enter a valid System Type");
            return;
        }
        this.invalidSystemType = false;
        if (this.projectId == undefined || this.projectId == null) {
            this.projectId = "";
        }
        this.systemTypeRepo.addSystemType(this.systemType, this.ownershipCodeGenerationType, this.createPermissionsOnlyInCallerIdentityProvider, this.projectId).subscribe(
            resp => {
                this.responseData = resp;
                if (this.responseData.statusCode === 201) {
                    this.notifier.displaySuccess(this.responseData.data);

                } else {
                    this.notifier.displayError(this.responseData.data.value);
                }
                
            },
            error => {
                this.notifier.displayApiResponseError(error);
               
            });
    }

    retrieveSystemTypes() {

        this.notifier.displayInfo("Retrieving system types");

        this.isSuccessRetriever = false;
        this.systemTypeRepo.retrieveSystemType().subscribe(
            resp => {
                this.responseData = resp;
                if (this.responseData) {
                    this.notifier.clear();
                    this.isSuccessRetriever = true;
                    this.retrievedSystemTypes = this.typeCastResponse(this.responseData);
                }
            },
            error => {            
                this.isSuccessRetriever = false;
                this.notifier.displayApiResponseError(error);
            });
    }
    typeCastResponse(response: any): Array<SystemTypeDetails> {
            this.resultMessage = "Retrieved Successfully";
            var retrievedSystemTypes = (response as ApiResponse).data as Array<SystemTypeDetails>;
            return retrievedSystemTypes;
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/systemTypeManagement/system-type-registration.component.ts
 **/